(function () {
  'use strict';

  document.querySelectorAll('.set-pdp').forEach(function (section) {
    var sectionId = section.dataset.sectionId;

    // === Image Gallery ===
    var mainImages = section.querySelectorAll('.set-pdp__main-image');
    var thumbs = section.querySelectorAll('.set-pdp__thumb');
    var totalImages = mainImages.length;
    var currentIndex = 0;

    function goToImage(idx) {
      if (idx < 0) idx = totalImages - 1;
      if (idx >= totalImages) idx = 0;
      currentIndex = idx;
      mainImages.forEach(function (img) {
        img.classList.toggle('set-pdp__main-image--active', parseInt(img.dataset.index, 10) === idx);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('set-pdp__thumb--active', parseInt(t.dataset.index, 10) === idx);
      });
      // Scroll active thumb into view
      var activeThumb = section.querySelector('.set-pdp__thumb--active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToImage(parseInt(thumb.dataset.index, 10));
      });
    });

    // Main image prev/next arrows
    var prevBtn = section.querySelector('[data-nav="prev"]');
    var nextBtn = section.querySelector('[data-nav="next"]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToImage(currentIndex + 1); });

    // Thumbnail strip prev/next arrows
    var thumbsPrev = section.querySelector('[data-thumbs-nav="prev"]');
    var thumbsNext = section.querySelector('[data-thumbs-nav="next"]');
    var thumbsContainer = section.querySelector('.set-pdp__thumbnails');
    if (thumbsPrev && thumbsContainer) {
      thumbsPrev.addEventListener('click', function () {
        thumbsContainer.scrollBy({ left: -160, behavior: 'smooth' });
      });
    }
    if (thumbsNext && thumbsContainer) {
      thumbsNext.addEventListener('click', function () {
        thumbsContainer.scrollBy({ left: 160, behavior: 'smooth' });
      });
    }

    // === Pricing Tab Switching ===
    var pricing = section.querySelector('.set-pdp__pricing');
    if (!pricing) return;

    var tabs = pricing.querySelectorAll('.set-pdp__tab');
    var spPicker = section.querySelector('[data-sp-picker]');
    var spSelect = section.querySelector('[data-sp-select]');
    var atcButton = section.querySelector('[data-atc-button]');
    var atcPrice = section.querySelector('[data-atc-price]');
    var atcCompare = section.querySelector('[data-atc-compare]');
    var variantId = pricing.dataset.variantId;

    var sellingPlans = [];
    var spJsonEl = document.getElementById('set-pdp-selling-plans-' + sectionId);
    if (spJsonEl) {
      try {
        sellingPlans = JSON.parse(spJsonEl.textContent);
      } catch (e) {}
    }

    var currentPlan = 'onetime';
    var currentSellingPlanId = null;

    function selectTab(tab) {
      tabs.forEach(function (t) { t.classList.remove('set-pdp__tab--active'); });
      tab.classList.add('set-pdp__tab--active');
      currentPlan = tab.dataset.plan;

      if (currentPlan === 'subscription') {
        if (spPicker) spPicker.style.display = '';
        currentSellingPlanId = tab.dataset.sellingPlanId || null;
        if (spSelect && currentSellingPlanId) {
          spSelect.value = currentSellingPlanId;
        }
        updatePricesFromSellingPlan();
      } else {
        if (spPicker) spPicker.style.display = 'none';
        currentSellingPlanId = null;
        updatePricesOnetime();
      }
      updateAtcLink();
    }

    tabs.forEach(function (tab) {
      var plan = tab.dataset.plan;

      if (plan === 'subscription') {
        // For subscription tab, the clickable area is .set-pdp__tab-top
        var tabTop = tab.querySelector('.set-pdp__tab-top');
        if (tabTop) {
          tabTop.addEventListener('click', function () {
            selectTab(tab);
          });
        }
      } else {
        // For one-time tab, the whole tab is clickable
        tab.addEventListener('click', function () {
          selectTab(tab);
        });
      }
    });

    // Selling plan select change — stop propagation so it doesn't trigger tab click
    if (spSelect) {
      spSelect.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      spSelect.addEventListener('change', function () {
        currentSellingPlanId = spSelect.value;
        // Update the data attribute on the tab for ATC link
        var subTab = pricing.querySelector('[data-plan="subscription"]');
        if (subTab) subTab.dataset.sellingPlanId = currentSellingPlanId;
        updatePricesFromSellingPlan();
        updateAtcLink();
      });
    }

    function updatePricesFromSellingPlan() {
      if (!currentSellingPlanId || !sellingPlans.length) return;
      var plan = null;
      for (var i = 0; i < sellingPlans.length; i++) {
        if (String(sellingPlans[i].sellingPlanId) === String(currentSellingPlanId)) {
          plan = sellingPlans[i];
          break;
        }
      }
      if (!plan) return;

      if (atcPrice) atcPrice.textContent = plan.priceFormatted;
      if (atcCompare) {
        if (plan.compareAtPrice > plan.price) {
          atcCompare.textContent = plan.compareAtPriceFormatted;
          atcCompare.style.display = '';
        } else {
          atcCompare.style.display = 'none';
        }
      }
    }

    function updatePricesOnetime() {
      var onetimePrice = section.querySelector('[data-onetime-price]');
      var onetimeCompare = section.querySelector('[data-onetime-compare]');
      if (atcPrice && onetimePrice) atcPrice.textContent = onetimePrice.textContent;
      if (atcCompare && onetimeCompare) {
        atcCompare.textContent = onetimeCompare.textContent;
        atcCompare.style.display = '';
      } else if (atcCompare) {
        atcCompare.style.display = 'none';
      }
    }

    function updateAtcLink() {
      if (!atcButton) return;
      // For one-time: simple cart permalink works
      // For subscription: need to POST via Cart API to include selling_plan
      if (currentPlan === 'subscription' && currentSellingPlanId) {
        atcButton.href = '#';
        atcButton.dataset.useCartApi = 'true';
      } else {
        atcButton.href = '/cart/' + variantId + ':1?storefront=true';
        atcButton.dataset.useCartApi = '';
      }
    }

    // Handle ATC click — use Cart API for subscriptions
    atcButton.addEventListener('click', function (e) {
      if (atcButton.dataset.useCartApi !== 'true') return; // let normal link work
      e.preventDefault();

      var item = {
        id: parseInt(variantId, 10),
        quantity: 1
      };
      if (currentSellingPlanId) {
        item.selling_plan = parseInt(currentSellingPlanId, 10);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (response) {
        if (response.ok) {
          window.location.href = '/cart';
        } else {
          response.json().then(function (data) {
            console.error('Cart add error:', data);
            // Fallback: redirect with URL params
            window.location.href = '/cart/' + variantId + ':1?storefront=true&selling_plan=' + currentSellingPlanId;
          });
        }
      }).catch(function () {
        // Fallback on network error
        window.location.href = '/cart/' + variantId + ':1?storefront=true&selling_plan=' + currentSellingPlanId;
      });
    });

    // Initialize: set onetime prices in ATC
    updatePricesOnetime();
  });
})();
